<footer class="page-footer">
  <p class="footer-text">Copyright © DAIICHI LIFE INSURANCE CO., LTD.All Rights Reserved.</p>
</footer>
